import { ProductOptionInterface, ProductVariantSizeColorInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';

export function getFilteredOptionsBySizeAndOrColor(
  options: ProductOptionInterface[] | null,
  values: ProductVariantSizeColorInterface | null,
): [string, string][] | null {
  if (!values || isEmpty(values) || !options) {
    return null;
  }

  const entries = Object.entries(values);

  // Filter out invalid values and ensure the correct type
  const filtered: [string, string][] = entries
    .filter(([key, value]) => {
      // Ensure value is not undefined
      if (!value) return false;

      // Check if the option exists in the options list
      return options.some((option) => option.name.toLowerCase() === key && option.values.includes(value));
    })
    .map(([key, value]) => [key, value as string]); // Type assertion to ensure it's [string, string]

  return filtered.length > 0 ? filtered : null;
}
